import storage from "./storage"

const HEADERS = {
  accept: "application/json",
  "content-type": "application/x-www-form-urlencoded",
}

function clear(self) {
  self.accessToken = null
  self.accessTokenExpiresAt = 0
  self.tokenType = null
  storage.remove("refreshToken")
}

function save(self, body) {
  self.accessToken = body.access_token
  self.accessTokenExpiresAt = Date.now() + body.expires_in * 1000
  self.tokenType = body.token_type
  storage.set("refreshToken", body.refresh_token)

  delete body.access_token
  delete body.token_type
  delete body.expires_in
  delete body.refresh_token

  return body
}

function request(method, params) {
  params.append("client_id", process.env.VUE_APP_API_CLIENT_ID)

  return fetch(`${process.env.VUE_APP_API_ORIGIN}/api/v4/token`, {
    method: method,
    headers: HEADERS,
    body: params.toString(),
  })
}

async function grant(self, params) {
  const response = await request("POST", params)
  if (response.status === 200) {
    return save(self, await response.json())
  }
  clear(self)
  return null
}

async function revoke(tokenType, token) {
  let params = new URLSearchParams()
  params.append("token", token)
  params.append("token_type_hint", tokenType)

  const response = await request("DELETE", params)

  if (response.status === 400) {
    const body = await response.json()
    throw new Error(`Bad OAuth request: ${body.error}`)
  }
  if (response.status === 401) {
    const body = await response.json()
    throw new Error(`OAuth client is unauthorized: ${body.error}`)
  }

  return response
}

export default {
  accessToken: null,
  accessTokenExpiresAt: 0,
  tokenType: null,

  isAuthenticated() {
    return this.accessToken && !this.hasExpired()
  },

  hasExpired() {
    return this.accessTokenExpiresAt <= Date.now()
  },

  shouldRefresh() {
    return this.hasExpired() && storage.has("refreshToken")
  },

  passwordGrant(username, password) {
    let params = new URLSearchParams()
    params.append("grant_type", "password")
    params.append("username", username)
    params.append("password", password)
    return grant(this, params)
  },

  refreshTokenGrant() {
    if (!storage.has("refreshToken")) {
      return null
    }
    let params = new URLSearchParams()
    params.append("grant_type", "refresh_token")
    params.append("refresh_token", storage.get("refreshToken"))
    return grant(this, params)
  },

  revokeAccessToken() {
    revoke("access_token", this.accessToken)
    clear(this)
  },

  revokeRefreshToken() {
    revoke("refresh_token", storage.get("refreshToken"))
    storage.remove("refreshToken")
  },
}
